module.exports = __webpack_public_path__ + "img/CRM_swiperTab_img2.f2553c4d.png";